import React from "react";
import "../../../shared/components/alert/succsessStyles.scss";
import { MdClose } from "react-icons/md";

interface IProps {
  children: any;
  show: boolean;
  onClose(): void;
}

const SuccsessAlert = (props: IProps) => {
  return (
    <div
      className={
        props.show ? "alertsuccess-wrapper animated fadeIn" : "alertsuccess-wrapper d-none"
      }
    >
      {props.children}
      <MdClose className="close-icon" onClick={props.onClose} />
    </div>
  );
};

export default SuccsessAlert;
